import { createAppStore } from '@store/createAppStore';

import { OldLoadStore } from './types';

export const [oldLoadsStore, setOldLoadsStore] = createAppStore<OldLoadStore>(
  {
    oldLoadsCount: 0,
  },
  'oldLoadsStore',
);
